<template>
    <div class="catalogue-card tw-snap-center tw-group" :class="[
        wrapperClasses,
    ]">
        <div class="tw-flex tw-flex-col">
            <!-- Thumbnail Section -->
            <a @click="handleClick" :href="isReleased && renderLink && !forceNoLinks ? itemUrl : null"
                class="tw-no-underline tw-flex tw-flex-col" :class="[item.type + '-thumbnail', isReleased && noAccess && !userHasExpiredMembership && !userHasBasicMembership ? 'tw-cursor-default' : '']">
                <div
                    class="tw-relative tw-overflow-hidden tw-rounded-[10px] tw-bg-white dark:tw-bg-[#0E2031] tw-aspect-video">
                    <!-- Video Thumbnail -->
                    <img :src="buildImageSRC(itemThumbnail, { width: 500, quality: 95 })"
                        class="tw-w-full tw-h-full tw-absolute tw-transition-opacity tw-duration-500 tw-opacity-0"
                        :class="[item.type === 'song' ? 'tw-blur-sm' : '']"
                         loading="lazy"
                         onload="this.classList.remove('tw-opacity-0')"
                    >
                    <!-- Song Overlay -->
                    <div v-if="item.type === 'song'"
                        class="tw-absolute tw-w-full tw-h-full tw-left-0 tw-top-0 tw-bg-black/70 tw-flex tw-justify-center">
                        <img class="tw-h-full tw-object-cover" :src="buildImageSRC(itemThumbnail, { width: 500, quality: 95 })"
                            :alt="itemTitle" />
                    </div>

                    <!-- Thumbnail Badge -->
                    <div v-if="thumbnailBadge"
                        class="tw-bg-black/70 tw-absolute tw-leading-none tw-uppercase tw-font-bold tw-bottom-1 tw-right-1 tw-rounded tw-text-white tw-text-[10px] tw-p-1">
                        {{ thumbnailBadge }}
                    </div>

                    <!-- Progress -->
                    <div class="lesson-progress overflow">
                        <span class="progress" :class="`tw-bg-${brand}`"
                            :style="'width:' + progress_percent + '%'"></span>
                    </div>
                    <div v-if="showTrophy" class="bundle-complete tw-justify-center">
                        <i class="fas fa-trophy"></i>
                    </div>

                    <!-- EVERYTHING ELSE -->
                    <div v-else
                        class="tw-absolute tw-flex tw-flex-col tw-w-full tw-h-full tw-justify-center tw-items-center tw-text-white tw-text-center"
                        :class="[{ 'tw-bg-[rgba(0,12,23,0.85)]': noAccess || !isReleased }, { 'tw-opacity-0 group-hover:tw-opacity-100 tw-bg-black/30': isReleased && !noAccess },]">
                        <i v-if="(!isReleased && noAccess) || !noAccess" class="fas" :class="thumbnailIcon"></i>
                        <p v-if="!isReleased" class="tw-mt-1 tw-text-sm text-white font-bold">
                            {{ releaseDate }}
                        </p>
                        <musora-icon v-else-if="noAccess" class="tw-w-[30px]" icon-name="lock-icon"></musora-icon>
                    </div>
                </div>
            </a>
            <!-- Description Section -->
            <div class="tw-flex tw-w-full">
                <div class="tw-w-full tw-flex tw-flex-wrap lg:tw-block">
                    <a @click="handleClick" :href="isReleased && renderLink && !forceNoLinks ? item.url : null"
                        class="card-info tw-flex tw-flex-auto tw-flex-col tw-rounded-lg tw-pt-2"
                        :class="isReleased && noAccess && !userHasExpiredMembership && !userHasBasicMembership ? 'tw-cursor-default' : ''">
                        <div class="tw-flex tw-flex-col">
                            <!-- Video Title -->
                            <h4 class="tw-text-sm tw-leading-snug tw-text-[#00101D] font-compressed tw-font-bold tw-capitalize tw-mb-1 dark:tw-text-white tw-line-clamp-2"
                                :class="{ 'tw-text-center': isGuitareoChordAndScale }">
                                {{ itemTitle }}
                            </h4>
                            <!-- Video Description -->
                            <p v-if="mappedData.show_description"
                                class="tw-text-xs tw-text-[#3F3F46] dark:tw-text-[#9EC0DC] tw-mb-1 tw-line-clamp-2"
                                v-html="item.description ?? mappedData.description"
                            ></p>
                            <!-- Content -->
                            <h6 class="tw-flex tw-items-center tw-flex-wrap tw-text-xs tw-font-normal tw-text-[#3F3F46] tw-uppercase dark:tw-text-[#9EC0DC] tw-mb-0.5"
                                :class="[{ 'tw-text-center': isGuitareoChordAndScale }]">
                                <div v-if="contentCreator && contentCreator !== ''" class="tw-mb-0.5">
                                    <span>{{ contentCreator }}</span>
                                </div>
                            </h6>
                        </div>
                        <p class="tw-flex tw-items-center tw-flex-wrap tw-text-xs tw-font-normal tw-text-[#3F3F46] tw-capitalize dark:tw-text-[#9EC0DC]">
                            <!-- Difficulty Label -->
                            <span v-if="itemDifficulty || itemDifficulty === 0" class="tw-flex tw-items-center">
                                <DifficultyLabel
                                    class="tw-text-xs"
                                    :difficultyValue="itemDifficulty"
                                    textCase="capitalize"
                                />
                                <span class="tw-mx-1 tw-text-base tw-leading-none">·</span>
                            </span>
                            <span>
                                {{ contentTypeString }}
                            </span>
                        </p>
                    </a>
                    <!-- CHALLENGE CTA's -->
                    <template v-if="contentType === 'challenge'">
                        <a v-if="enrollmentOpen && !hasProduct" :href="registrationUrl"
                            class="tw-mt-1 tw-inline-flex tw-items-center tw-justify-center tw-uppercase tw-text-sm tw-px-4 tw-leading-none tw-font-bebas-neue tw-h-[36px] tw-rounded-2xl tw-shadow tw-bg-white dark:tw-bg-[#0E2031] dark:tw-text-[#F1F1F1] tw-text-[#00101D]">
                            Enroll Now
                        </a>
                        <button v-if="upcomingChallenge" data-open-modal="notifyModal"
                            class="tw-mt-1 tw-inline-flex tw-items-center tw-justify-center tw-uppercase tw-text-sm tw-px-4 tw-leading-none tw-font-bebas-neue tw-h-[36px] tw-rounded-2xl tw-shadow tw-bg-white dark:tw-bg-[#0E2031] dark:tw-text-[#F1F1F1] tw-text-[#00101D]">
                            <musora-icon icon-name="bell" class="tw-w-5 tw-h-5 tw-mr-1" />
                            Notify Me
                        </button>
                    </template>
                </div>
                <!--
                    Add to Playlist
                    Don't show if the user has not enrolled in a challenge (does not own Product)
                -->
                <div v-if="!enrollmentOpen || hasProduct"
                    class="tw-inline-flex tw-items-start tw-pt-1 tw-px-1 tw-relative">
                    <div class="tw-relative" v-click-outside="() => { state.dropdownOpen = false }">
                        <button :id="`${item.id}-action-btn-big`" v-if="showMyListAction"
                            class="add-to-list tw-inline-flex tw-rounded-full tw-p-0.5 tw-text-[#00101D] dark:tw-text-white"
                            :class="is_added ? 'is-added' + `tw-text-${brand}` : 'tw-text-[#00101D] dark:tw-text-white'"
                            :title="is_added ? 'Remove from Playlist' : 'Add to Playlist'" :data-content-id="item.id"
                            :data-content-type="item.type"
                            @click.prevent="showDropdown ? handleShowDropdown(`${item.id}-action-btn-big`) : $emit('addToList', { content_id: item.id, type: item.type, name: itemTitle, description: mappedData.description, thumbnail_url: itemThumbnail })">
                            <DotsHorizontalIcon v-if="showDropdown" class="tw-h-[24px] tw-w-[24px]" />
                            <svg v-else xmlns="http://www.w3.org/2000/svg" class="tw-h-7 tw-w-7" fill="none"
                                viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4v16m8-8H4" />
                            </svg>
                        </button>

                        <Dropdown v-if="showDropdown" :brand="brand" :item="item" :is-open="state.dropdownOpen"
                            :dropdownOptions="dropdownOptions"
                            @closeDropdown="closeDropdown()"
                            :position="state.dropdownPosition"
                            @addToList="$emit('addToList', { content_id: item.id, type: item.type, name: itemTitle, description: mappedData.description, thumbnail_url: itemThumbnail })"
                            @progressReset="$emit('progressReset', { content_id: item.id })"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { computed, onUnmounted, ref, reactive, onMounted, onBeforeMount } from 'vue';
import { DotsHorizontalIcon } from '@heroicons/vue/outline';
import useCatalogueItem from '@hooks/useCatalogueItem.js';
import Dropdown from './Dropdown';
import DifficultyLabel from '@units/DifficultyLabel/DifficultyLabel';
import { contentTypes } from "../../../utils";
import { storeToRefs } from 'pinia';
import { useUserStore } from '@stores/user';
import MusoraIcon from '@units/MusoraIcons/MusoraIcon.vue';
import userJourney from '@services/userJourney';
import { usePlatformStore } from "../../../Stores/platform";
import { buildImageSRC } from 'musora-content-services'

//Pinia Stores
const userStore = useUserStore();
const platformStore = usePlatformStore();
const { brand, userHasExpiredMembership, userHasBasicMembership } = storeToRefs(userStore);

const props = defineProps({
    item: {
        type: Object,
        default: () => ({}), // Default empty object
    },
    contentType: {
        type: String,
        default: '' // Default empty string
    },
    wrapperClassOverride: {
        type: String,
        default: ''
    },
    breakToListView: {
        type: Boolean,
        default: false
    },
    lockUnowned: {
        type: Boolean,
        default: false
    },
    contentTypeOverride: {
        type: String,
        default: ''
    },
    showMyListAction: {
        type: Boolean,
        default: false
    },
    forceNoLinks: {
        type: Boolean,
        default: false
    },
    showDropdown: {
        type: Boolean,
        default: false
    },
    fullWidthOnMobile: {
        type: Boolean,
        default: () => false,
    },
    isSingleRow: {
        type: Boolean,
        default: () => false,
    },
    scrollContainer: {
        type: String,
        default: 'content-container'
    },
    trackingSection: {
        type: String,
        default: '',
    },
});

const {
    noAccess,
    contentModel,
    thumbnailIcon,
    renderLink,
    isReleased,
    releaseDate,
    progress_percent,
    isCompleted,
} = useCatalogueItem(props);

const state = reactive({
    dropdownOpen: false,
    dropdownPosition: {
        top: 0,
        left: 0,
        opacity: 0,
    }
});

//-----------Static Data-----------//
const dropdownOptions = [
    {
        name: "Add to Playlist",
        action: "addToList"
    },
    {
        name: "Reset Progress",
        action: "progressReset"
    },
]

const handleShowDropdown = (className) => {
    const { top, left } = document.getElementById(className).getBoundingClientRect();
    const { innerHeight, innerWidth } = window;

    state.dropdownOpen = !state.dropdownOpen;

    //opacity 0 to avoid flicker
    state.dropdownPosition = { ...state.dropdownPosition, opacity: 0 }

    //wait for element to appear on screen
    window.setTimeout(() => {
        const { width, height } = document.getElementById('catalogue-card-dropdown-div').getBoundingClientRect();

        state.dropdownPosition = {
            top: (top + height + 30) < innerHeight ? top + 30 : top - height,
            left: (left + width) < innerWidth ? left : left - width + 26,
            opacity: 1,
        };
    }, 0)
};

const contentTypeString = computed(() => {
    if (contentModel.value?.post?.type && contentTypes[contentModel.value.post.type]?.singular) {
        return contentTypes[contentModel.value.post.type].singular
    } else if (props.item.type) {
        return props.item.type;
    }
    return '';
})

const isSongContent = computed(() => {
    return contentModel.value.post.type === 'song'
})

const hasProduct = computed(() => {
    return contentModel.value.post.has_product;
})

const registrationUrl = computed(() => {
    return contentModel.value?.post?.fields.find(field => field.key === 'registration_url')?.value || '';
})

const duration = computed(() => {
    let time;
    if (props.item.fields) {
        time = props.item.fields?.find(field => field.key === 'length_in_seconds')?.value;
    } else {
        time = props.item.length_in_seconds ?? 0;
    }

    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;
    return `${hours ? `${hours}:` : ''}${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
})

const enrollmentOpen = computed(() => {
    return contentModel.value.post.challenge_state === 'enrollment';
})

const thumbnailBadge = computed(() => {
    if (props.item.type === 'challenge') {
        if (enrollmentOpen.value && !contentModel.value.post.has_product) return 'Enroll Now';
        if (upcomingChallenge.value) return 'Upcoming';
        return `${props.item.child_count} Workouts`;
    } else if (props.item.type === 'workout' && duration.value !== '0:00') {
        return duration.value;
    } else if ((props.item.type === 'course' || props.item.type === 'pack-bundle') && props.item.lesson_count) {
        return `${props.item.lesson_count} Lessons`;
    } else if (duration.value !== '0:00') {
        return duration.value;
    }
})

const upcomingChallenge = computed(() => {
    return contentModel.value.post.challenge_state === 'upcoming';
})

const contentCreator = computed(() => {
    if (contentModel.value?.post?.fields) {
        if (isSongContent.value) {
            return contentModel.value?.post?.fields.find(field => field.key === 'artist')?.value || ''
        }
        return contentModel.value?.post?.fields.find(field => field.key === 'instructor')?.value.name || ''
    } else if (props.item.artist_name) {
        return props.item.artist_name;
    } else {
        return '';
    }
})

const mappedData = computed(() => {
    let difficultyValue = 0; //default
    if (contentModel.value?.post?.fields) {
        difficultyValue = contentModel.value?.post?.fields.find(field => field.key === 'difficulty')?.value || 0;
    }

    contentModel.value.card.difficulty = difficultyValue;

    return contentModel.value.card
});

//New Sanity Values
const itemThumbnail = computed( () => {
    return props.item.image ?? mappedData.value.thumbnail;
})
const itemTitle = computed( () => {
    return props.item.title ?? mappedData.value.black_title;
})
const itemDifficulty = computed( () => {
    return props.item.difficulty ?? mappedData.value.difficulty;
})
const itemUrl = computed( ()=> {
    return props.item.web_url_path ?? props.item.url;
})

const wrapperClasses = computed(() => {
    const defaultWrapperClasses = 'tw-flex tw-flex-col tw-shrink-0 tw-w-[279px] lg:tw-w-1/4 2xl:tw-w-1/5 tw-pr-3';
    return ({
        [defaultWrapperClasses]: defaultWrapperClasses && !props.wrapperClassOverride,
        'no-access': noAccess.value,
        completed: isCompleted.value,
        'lg:[&:nth-child(n+5)]:tw-hidden 2xl:[&:nth-child(n+5)]:tw-flex 2xl:[&:nth-child(n+6)]:tw-hidden': props.isSingleRow,
        [props.wrapperClassOverride]: props.wrapperClassOverride,
    })
});

const is_added = computed(() => props.item.is_added_to_primary_playlist);
const showTrophy = computed(() => props.item.type === 'pack-bundle' && isCompleted.value);
const isGuitareoChordAndScale = computed(() => brand === 'guitareo' && props.item.type === 'chord-and-scale');

const closeDropdown = () => {
    if (state.dropdownOpen) {
        state.dropdownOpen = false;
    }
};

const getPublishedOn = (item) => {
    const dt = DateTime.fromSQL(item.published_on, { zone: 'utc' });
    return dt.setZone('America/Los_Angeles').toFormat('LLL dd, yyyy');
}

const emit = defineEmits(['addToList', 'progressReset']);

const handleClick = (event) => {
    if (isReleased.value && noAccess.value && userHasExpiredMembership.value) {
        event.preventDefault();
        platformStore.redirectToMembershipRenewal(userStore.brand);
    } else if (isReleased.value && noAccess.value && userHasBasicMembership.value) {
        event.preventDefault();
        platformStore.openMembershipUpgradeModal(brand.value);
    } else if (isReleased.value && noAccess.value) {
        event.preventDefault();
        // no-op
    } else {
        if (isReleased.value && renderLink.value && !props.forceNoLinks && props.trackingSection && props.trackingSection.length) {
            event.preventDefault();

            userJourney.trackHomeContentClick({
                payload: {
                    contentId: props.item.id,
                    brand: brand.value,
                    section: props.trackingSection,
                }
            }).finally(() => {
                window.location.href = itemUrl.value;
            });
        }
    }
}

onMounted(() => {
    const contentContainer = document.getElementById(props.scrollContainer);
    contentContainer.addEventListener('scroll', closeDropdown);
});

onUnmounted(() => {
    const contentContainer = document.getElementById(props.scrollContainer);
    contentContainer.removeEventListener('scroll', closeDropdown);
});

</script>
